var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Default View")]),_vm._v(" "),_c('p',[_vm._v("this is the component that will contain the dashboard homepage information. Widgets and such with snap shot information about all of the users profiles and tracks. Likes and comments composite information. Top level birds eye view of their account.")])])
}]

export { render, staticRenderFns }